import React from 'react'
import { PrismicRichText, PrismicLink } from '@prismicio/react'
import { GatsbyImage } from 'gatsby-plugin-image'

const Card = ({ fields }) => {
  return (
    <li className={`component-card ease group relative flex transform flex-col md:m-2`}>
      {fields.image.gatsbyImageData && (
        <div className='relative aspect-4/3 overflow-hidden'>
          <div className='prose prose-invert absolute left-0 top-0 z-10 max-w-none bg-brand-light-blue p-4 md:prose-lg md:px-6'>
            <PrismicRichText field={fields.title.richText} />
          </div>
          <GatsbyImage
            className={`${fields.button_link?.url != null && 'transition duration-500 ease-in group-hover:scale-105'} h-full w-full transform`}
            image={fields.image.gatsbyImageData}
            alt={fields.image.alt || ''}
          />
        </div>
      )}
      {(fields.button_link?.url || (!fields.image.gatsbyImageData && fields.title.text) || fields.text.text) && (
        <div className='mx-6 flex flex-grow -translate-y-6 flex-col gap-4 bg-white p-4 md:px-6'>
          <div className='prose max-w-none md:prose-lg'>
            {!fields.image.gatsbyImageData && <PrismicRichText field={fields.title.richText} />}
            <PrismicRichText field={fields.text.richText} />
          </div>
          {fields.button_link?.url && (
            <div className='mt-auto'>
              <PrismicLink className={`${fields.button_text ? 'button' : 'link'} lg:text-xl`} href={fields.button_link?.url}>
                {fields.button_text}
                <span className='absolute inset-0' aria-hidden='true'></span>
              </PrismicLink>
            </div>
          )}
        </div>
      )}
    </li>
  )
}

export default Card
